import type { ReactNode } from "react";
import { Button } from "zhihao-ui-react";

const errorCopy: Record<number, { title: string; tip: string }> = {
    403: { title: "暂无权限操作", tip: "请联系管理员开通账号/权限" },
    404: { title: "页面不存在", tip: "请检查访问地址后重试" },
    500: { title: "服务异常", tip: "请稍后重试或联系管理员" }
};

export function ErrorPage({ status, actions }: { status: number; actions?: ReactNode }) {
    const copy = errorCopy[status] || errorCopy[500];
    return (
        <main className="public-page public-page--error" data-error-status={status}>
            <div role="img" aria-label={`错误${status}`} className="public-page__status">
                {status}
            </div>
            <h1>{copy.title}</h1>
            <p>{copy.tip}</p>
            {status !== 403 ? (
                <Button type="primary" onClick={() => window.history.back()}>
                    返回上一页
                </Button>
            ) : null}
            {actions}
        </main>
    );
}

export default ErrorPage;
